import API from './API';

export default abstract class BFFAPI extends API {
  /**
   * Always start endpoint with /
   */
  constructor(endpoint: string) {
    const bffEndpoint = String(process.env.ENDPOINT_BFF || '');
    if (!bffEndpoint) {
      throw new ReferenceError('BFF Endpoint is not defined');
    }

    super(bffEndpoint.concat(endpoint));
  }
}
